/* oz-search-placeholder.js — Rotating placeholder pour les barres de recherche
 * Source des textes : window.OzSearchTexts (injecté via theme.liquid depuis settings_schema)
 * Fonctionne sur [data-oz-search-input] (réel + trigger readonly + drawer).
 * Rotation continue — ne s'arrête PAS au focus.
 * Se masque uniquement quand l'input contient du texte (event 'input').
 * ================================================================ */
(function () {
  'use strict';

  /* Textes depuis theme settings — injection dans theme.liquid
     Fallback si window.OzSearchTexts absent (ex: email preview) */
  var TEXTS = (window.OzSearchTexts && window.OzSearchTexts.length)
    ? window.OzSearchTexts.map(function (t) { return t.trim(); }).filter(Boolean)
    : ['118', 'Pour Homme', 'Inspiré par Eau Sauvage', 'Rechercher un parfum'];

  var INTERVAL = 2800;  /* ms entre chaque rotation */
  var FADE     = 150;   /* ms = durée transition CSS */

  function initInput(input) {
    if (input.dataset.ozPlaceholderInit) return;
    input.dataset.ozPlaceholderInit = 'true';

    /* ── Wrapper positionné (injecté en JS pour ne pas alourdir le Liquid) ── */
    var wrapper = document.createElement('span');
    wrapper.className = 'oz-ph-wrapper';
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    /* ── Overlay span ── */
    var span = document.createElement('span');
    span.className = 'oz-ph-text';
    span.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(span);

    /* Vide le placeholder natif pour éviter le doublon visuel */
    input.setAttribute('placeholder', '');

    var idx = 0;
    span.textContent = TEXTS[0];
    span.style.opacity = '1';

    /* ── Rotation — continue même au focus ── */
    setInterval(function () {
      /* Masqué si l'input contient du texte */
      if (input.value) return;

      span.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % TEXTS.length;
        span.textContent = TEXTS[idx];
        if (!input.value) {
          span.style.opacity = '1';
        }
      }, FADE);
    }, INTERVAL);

    /* ── Masquage/affichage au moment où l'utilisateur tape ── */
    input.addEventListener('input', function () {
      if (input.value) {
        span.style.opacity = '0';
        span.style.display = 'none';
      } else {
        span.style.display = '';
        span.style.opacity = '1';
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-oz-search-input]').forEach(initInput);
  }

  /* ── Init initiale ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Re-init à l'ouverture de la popup Minimog ── */
  document.addEventListener('search:opened',         initAll);
  document.addEventListener('m-search-popup:opened', initAll);

  /* ── MutationObserver sur la popup : détecte visibility:visible ── */
  var searchPopup = document.querySelector('[data-search-popup]');
  if (searchPopup) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'style') {
          if (m.target.style.visibility !== 'hidden') initAll();
        }
      });
    }).observe(searchPopup, { attributes: true });
  }
})();
